.MicrosoftDynamicsLoginForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 20px 0 20px;

  .Email {
    max-width: 455px;
    width: 100%;
    display: flex;
    border-radius: 4px;

    @include themify($themes) {
      background-color: themed("background");
    }

    &.EmailError {
      @include themify($themes) {
        background-color: themed("error_background");
      }
    }

    @include themify($themes) {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 14px;
      color: themed("font_secondary");
    }
  }

  .CustomDomainButton {
    align-self: center;
    margin-top: 6px;
    background: none;
    border: none;
    padding: 0;
    width: 281px;
    height: 38px;
    cursor: pointer;

    @include themify($themes) {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 38px;
      color: themed("font_secondary");
    }

    span {
      @include themify($themes) {
        color: themed("link_font");
      }
    }
  }

  .CustomDomain {
    margin-top: 15px;
    width: 410px;
    display: flex;
    padding: 21.5px 15px 24.5px 15px;
    border: 1px solid #d8dde3;
    border-radius: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    @include themify($themes) {
      background-color: themed("background");
    }

    &.CustomDomainError {
      @include themify($themes) {
        background-color: themed("error_background");
      }
    }

    @include themify($themes) {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 14px;
      color: themed("font_secondary");
    }
  }

  .ErrorMessage {
    margin-top: 5px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    @include themify($themes) {
      color: themed("error_font");
    }
  }

  .Submit {
    font-family: inherit;
    align-self: center;
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 14px 12px;
    gap: 15px;
    width: 225px;
    height: 50px;
    outline: none;
    @include themify($themes) {
      color: themed("font_primary");
      background: themed("submit_background");

      &:hover {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), themed("submit_background_hover");
      }
    }
    border-radius: 281px;
  }

  .Loader {
    margin-top: 10px;
    align-self: center;
    @include themify($themes) {
      color: themed("submit_background");
    }
  }

  .ConnectErrorMessage {
    margin-top: 10px;
    align-self: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    padding: 0 10px;
    user-select: text;
    max-width: 700px;
    
    @include themify($themes) {
      color: themed("error_font");
    }
  }

  .termsAndPrivacy {
    line-height: 22px;
    margin-top: 24px;
    font-size: 14px;
    width: 250px;
    text-align: center;

    a {
      text-decoration: underline;
    }
  }
}

.selectBottomText {
  white-space: break-spaces;
  display: flex;
  column-gap: 6px;
  font-size: 12px;
  align-items: center;

  svg {
    cursor: default;
    height: 12px;
    width: 12px;
  }
  
  @include themify($themes) {
    .svgContainer {
      background-color: themed("neutral-tertiary");
      height: 25px;
      min-width: 25px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.hiddenEmailInputField {
  display: none;
}

.needMicrosoftDynamicsUserNameContainer {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  span {
    text-decoration: underline;
    white-space: nowrap;
    cursor: pointer;
  }
}

.InputsContainer {
  width: 100%;
  max-width: 445px;
}

.ButtonsContainer {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  column-gap: 12px;
}

.callToAction {
  @include themify($themes) {
    color: themed("neutral-primary");
  }
  span {
    text-decoration: none;
    @include themify($themes) {
      color: themed("brand-tertiary");
    }
  }
}
